import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query';
import {fetchDeletedChats, restoreChat} from './deleted-items-api';

export const useDeletedChats = (page = 0, pageSize = 20) =>
    useQuery({
        queryKey: ['deleted-chats', page, pageSize],
        queryFn: () => fetchDeletedChats(page, pageSize),
        keepPreviousData: true,
    });

export const useRestoreChat = (onSuccess) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (id) => restoreChat(id),
        onSuccess: () => {
            // BOTH lists. Invalidating only the live one leaves the restored conversation still
            // sitting in the deleted view, which reads as "the restore did not work".
            queryClient.invalidateQueries({queryKey: ['deleted-chats']});
            queryClient.invalidateQueries({queryKey: ['chats']});
            onSuccess?.();
        },
    });
};
